/* eslint-disable no-shadow */
/* This right now includes a bit more than only payment statuses
   In future this should be replaced with a different status field and enum
*/
var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["started"] = "started";
    OrderPaymentStatus["paymentStarted"] = "paymentStarted";
    OrderPaymentStatus["paymentFailed"] = "paymentFailed";
    OrderPaymentStatus["paid"] = "paid";
    OrderPaymentStatus["canceled"] = "canceled";
    OrderPaymentStatus["paidAndCanceled"] = "paidAndCanceled";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
var PurchaseEntity;
(function (PurchaseEntity) {
    PurchaseEntity["person"] = "person";
    PurchaseEntity["organization"] = "organization";
})(PurchaseEntity || (PurchaseEntity = {}));
var OrderType;
(function (OrderType) {
    OrderType["general"] = "general";
    OrderType["prolongation"] = "prolongation";
    OrderType["reconciliation"] = "reconciliation";
})(OrderType || (OrderType = {}));
var ManualOrderItemStatus;
(function (ManualOrderItemStatus) {
    ManualOrderItemStatus["empty"] = "empty";
    ManualOrderItemStatus["canceled"] = "canceled";
    ManualOrderItemStatus["paidAndCanceled"] = "paidAndCanceled";
})(ManualOrderItemStatus || (ManualOrderItemStatus = {}));
var ReminderType;
(function (ReminderType) {
    ReminderType["PICKUP"] = "PICKUP";
    ReminderType["RETURN"] = "RETURN";
    ReminderType["EXPIRED"] = "EXPIRED";
    ReminderType["SMS_PICKUP"] = "SMS_PICKUP";
})(ReminderType || (ReminderType = {}));
var DetectionReason;
(function (DetectionReason) {
    DetectionReason["EMPTY"] = "EMPTY";
    DetectionReason["ENTRY"] = "ENTRY";
    DetectionReason["RFID"] = "RFID";
    DetectionReason["GPS"] = "GPS";
    DetectionReason["PIN"] = "PIN";
    DetectionReason["MANUAL"] = "MANUAL";
    DetectionReason["SELF_REPORTED"] = "SELF_REPORTED";
})(DetectionReason || (DetectionReason = {}));
var PickupStatus;
(function (PickupStatus) {
    PickupStatus["EMPTY"] = "EMPTY";
    PickupStatus["PICKEDUP"] = "PICKEDUP";
    PickupStatus["RETURNED"] = "RETURNED";
    PickupStatus["INSPECTED"] = "INSPECTED";
    PickupStatus["COMPLETED"] = "COMPLETED";
})(PickupStatus || (PickupStatus = {}));
var RebateCauseType;
(function (RebateCauseType) {
    RebateCauseType["PERSONAL_REBATE"] = "PERSONAL_REBATE";
    RebateCauseType["ORGANIZATION_REBATE"] = "ORGANIZATION_REBATE";
    RebateCauseType["MANUAL_PERSONAL_REBATE"] = "MANUAL_PERSONAL_REBATE";
})(RebateCauseType || (RebateCauseType = {}));
var RerentState;
(function (RerentState) {
    RerentState["OPENED"] = "OPENED";
    RerentState["DECLINED"] = "DECLINED";
    RerentState["APPROVED"] = "APPROVED";
})(RerentState || (RerentState = {}));
var RerentOrderState;
(function (RerentOrderState) {
    RerentOrderState["OPENED"] = "OPENED";
    RerentOrderState["DECLINED"] = "DECLINED";
    RerentOrderState["APPROVED"] = "APPROVED";
    RerentOrderState["PAID"] = "PAID";
    RerentOrderState["COMPLETED"] = "COMPLETED";
    RerentOrderState["ASSEMBLING"] = "ASSEMBLING";
})(RerentOrderState || (RerentOrderState = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["NONE"] = "NONE";
    PaymentMethod["MANUAL"] = "MANUAL";
    PaymentMethod["PAYMENT_LINK"] = "PAYMENT_LINK";
    PaymentMethod["INVOICE"] = "INVOICE";
    PaymentMethod["PAID_AT_POS"] = "PAID_AT_POS";
    PaymentMethod["PAID_BY_OPERATOR_INVOICE"] = "PAID_BY_OPERATOR_INVOICE";
    PaymentMethod["HYGGLO"] = "HYGGLO";
})(PaymentMethod || (PaymentMethod = {}));
var CreationLocation;
(function (CreationLocation) {
    CreationLocation["ADMIN"] = "ADMIN";
    CreationLocation["ECOMMERCE"] = "ECOMMERCE";
})(CreationLocation || (CreationLocation = {}));
var ReconciliationReason;
(function (ReconciliationReason) {
    ReconciliationReason["REPAIR"] = "REPAIR";
    ReconciliationReason["CREDITS_VAT_REDUCTION"] = "CREDITS_VAT_REDUCTION";
    ReconciliationReason["BROKEN"] = "BROKEN";
    ReconciliationReason["CLEANING"] = "CLEANING";
    ReconciliationReason["LATE_DELIVERY"] = "LATE_DELIVERY";
    ReconciliationReason["FEE"] = "FEE";
    ReconciliationReason["GENERIC"] = "GENERIC";
    ReconciliationReason["MANUAL_RECOMPENSATION"] = "MANUAL_RECOMPENSATION";
    ReconciliationReason["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
})(ReconciliationReason || (ReconciliationReason = {}));
var CompletedReason;
(function (CompletedReason) {
    CompletedReason["EMPTY"] = "EMPTY";
    CompletedReason["INSPECTED"] = "INSPECTED";
    CompletedReason["REASSIGNED"] = "REASSIGNED";
    CompletedReason["REPAIRED"] = "REPAIRED";
    CompletedReason["BROKEN"] = "BROKEN";
})(CompletedReason || (CompletedReason = {}));
var OfferOrderStatus;
(function (OfferOrderStatus) {
    OfferOrderStatus["PENDING"] = "PENDING";
    OfferOrderStatus["SENT"] = "SENT";
})(OfferOrderStatus || (OfferOrderStatus = {}));
var OfferItemResponseStatus;
(function (OfferItemResponseStatus) {
    OfferItemResponseStatus["NONE"] = "NONE";
    OfferItemResponseStatus["DECLINED"] = "DECLINED";
    OfferItemResponseStatus["ACCEPTED"] = "ACCEPTED";
    OfferItemResponseStatus["DECLINED_BY_MANAGER"] = "DECLINED_BY_MANAGER";
})(OfferItemResponseStatus || (OfferItemResponseStatus = {}));
var OfferItemCancelledStatus;
(function (OfferItemCancelledStatus) {
    OfferItemCancelledStatus["NONE"] = "NONE";
    OfferItemCancelledStatus["CANCELLED"] = "CANCELLED";
})(OfferItemCancelledStatus || (OfferItemCancelledStatus = {}));
var OfferItemSelectStatus;
(function (OfferItemSelectStatus) {
    OfferItemSelectStatus["NONE"] = "NONE";
    OfferItemSelectStatus["SELECTED"] = "SELECTED";
    OfferItemSelectStatus["TOO_LATE"] = "TOO_LATE";
    OfferItemSelectStatus["LOST"] = "LOST";
})(OfferItemSelectStatus || (OfferItemSelectStatus = {}));
var OfferItemProcessingStatus;
(function (OfferItemProcessingStatus) {
    OfferItemProcessingStatus["NONE"] = "NONE";
    OfferItemProcessingStatus["PROCESSED"] = "PROCESSED";
    OfferItemProcessingStatus["APPROVED"] = "APPROVED";
    OfferItemProcessingStatus["DECLINED"] = "DECLINED";
    OfferItemProcessingStatus["CANCELLED"] = "CANCELLED";
    OfferItemProcessingStatus["PAID"] = "PAID";
    OfferItemProcessingStatus["PAID_AND_CANCELLED"] = "PAID_AND_CANCELLED";
    OfferItemProcessingStatus["PICKEDUP"] = "PICKEDUP";
    OfferItemProcessingStatus["RETURNED"] = "RETURNED";
    OfferItemProcessingStatus["INSPECTED"] = "INSPECTED";
    OfferItemProcessingStatus["COMPLETED"] = "COMPLETED";
})(OfferItemProcessingStatus || (OfferItemProcessingStatus = {}));
var OrderOrigin;
(function (OrderOrigin) {
    OrderOrigin["LEID"] = "LEID";
    OrderOrigin["MANAGER"] = "MANAGER";
})(OrderOrigin || (OrderOrigin = {}));
var AccessorySelectionType;
(function (AccessorySelectionType) {
    AccessorySelectionType["MANDATORY"] = "MANDATORY";
    AccessorySelectionType["PRE_SELECTED"] = "PRE_SELECTED";
    AccessorySelectionType["OPTIONAL"] = "OPTIONAL";
})(AccessorySelectionType || (AccessorySelectionType = {}));
var OrderProductUsage;
(function (OrderProductUsage) {
    OrderProductUsage["REGULAR"] = "REGULAR";
    OrderProductUsage["CONSUMABLE"] = "CONSUMABLE";
    OrderProductUsage["SERVICE"] = "SERVICE";
})(OrderProductUsage || (OrderProductUsage = {}));
// Different string format due to task module
var OrderItemInspectionReason;
(function (OrderItemInspectionReason) {
    OrderItemInspectionReason["ASSET_INSPECT"] = "assetInspect";
    OrderItemInspectionReason["ASSET_VISUAL_INSPECT"] = "assetVisualInspect";
    OrderItemInspectionReason["ASSET_INSPECTION_FAILED"] = "assetInspectionFailed";
    OrderItemInspectionReason["ORDER_INSPECT"] = "orderInspect";
    OrderItemInspectionReason["PRODUCT_INSPECT"] = "productInspect";
})(OrderItemInspectionReason || (OrderItemInspectionReason = {}));
var DiscountCodeValidationError;
(function (DiscountCodeValidationError) {
    DiscountCodeValidationError["NOT_FOUND"] = "NOT_FOUND";
    DiscountCodeValidationError["CODE_INACTIVE"] = "CODE_INACTIVE";
    DiscountCodeValidationError["CODE_EXPIRED"] = "CODE_EXPIRED";
    DiscountCodeValidationError["ALREADY_USED"] = "ALREADY_USED";
})(DiscountCodeValidationError || (DiscountCodeValidationError = {}));

export { AccessorySelectionType, CompletedReason, CreationLocation, DetectionReason, DiscountCodeValidationError, ManualOrderItemStatus, OfferItemCancelledStatus, OfferItemProcessingStatus, OfferItemResponseStatus, OfferItemSelectStatus, OfferOrderStatus, OrderItemInspectionReason, OrderOrigin, OrderPaymentStatus, OrderProductUsage, OrderType, PaymentMethod, PickupStatus, PurchaseEntity, RebateCauseType, ReconciliationReason, ReminderType, RerentOrderState, RerentState };
//# sourceMappingURL=enums.js.map
